export var MimeType;
(function (MimeType) {
    MimeType["JPEG"] = "image/jpeg";
    MimeType["PNG"] = "image/png";
})(MimeType || (MimeType = {}));
